import { MediaTranslationsManagerModal } from "./components/AdForm/MediaTranslationsManagerModal";
import { NanoBananaMediasTranslation } from "./components/AdForm/NanoBananaMediasTranslation";
import { SupplierProductManager } from "./components/AdForm/SupplierProductManager";
import ProcessModal from "./components/Processes/ProcessModal";
import TaskModal from "./components/TaskModal";

export const MODAL_LIST = {
  mediaTranslation: {
    component: MediaTranslationsManagerModal,
    args: ['mediaId'],
  },
  nanoBananaMediasTranslation: {
    component: NanoBananaMediasTranslation,
    args: ['mediaIds'],
  },
  task: {
    component: TaskModal,
    args: ['taskId'],
  },
  supplierProduct: {
    component: SupplierProductManager,
    args: ['supplierProductId'],
  },
  processModal: {
    component: ProcessModal,
    args: ['processId'],
  },
}